import { Column, Row } from '@tanstack/react-table';
import { Button } from '@chakra-ui/react';

import {
  EmployeeBulkActions,
  GiftingEmployeesBulkActions,
  AdminBulkActions,
} from 'app/components/UI/Table/Table.types';

import { SortArrowsAscBold, SortArrowsDescBold } from '@aslanpay/portal-common-lib';

import { getEmployeeBulkActionsValues } from './employees';
import { getGiftingEmployeeBulkActionsValues } from './gifting/employees';
import { getGiftingAdminBulkActionsValues } from './gifting/admins';
import { getRewardEmployeesBulkActions } from './rewardEmployees';

function getRewardEmployeesBulkActionsValues(
  actions: ReturnType<typeof getRewardEmployeesBulkActions>
) {
  const bulkActions = [];

  if (actions.next) {
    bulkActions.push(
      <Button
        key="next"
        size="sm"
        colorScheme="brand"
        onClick={() => actions.next.action()}
        isDisabled={actions.next.isDisabled}
      >
        Next
      </Button>
    );
  }

  return {
    label: 'employee',
    bulkActions,
  };
}

export function getSortIcon<TData extends object>(column: Column<TData>) {
  if (!column.getCanSort()) return null;

  if (column.getIsSorted() === 'desc') {
    return <SortArrowsDescBold color="brand.purple" boxSize="15px" />;
  }

  return (
    <SortArrowsAscBold
      color={column.getIsSorted() === 'asc' ? 'brand.purple' : 'brand.darkGray'}
      boxSize="15px"
    />
  );
}

export function getBulkActionsValues<TData extends object>(
  type: 'employee' | 'giftingEmployees' | 'giftingAdmins' | 'rewardEmployee',
  actions:
    | EmployeeBulkActions
    | GiftingEmployeesBulkActions
    | AdminBulkActions
    | ReturnType<typeof getRewardEmployeesBulkActions>,
  selectedRows: Row<TData>[]
) {
  // selectedRows is used in the switch statement logic
  switch (type) {
    case 'employee':
      return getEmployeeBulkActionsValues(actions as EmployeeBulkActions, selectedRows);
    case 'giftingEmployees':
      return getGiftingEmployeeBulkActionsValues(
        actions as GiftingEmployeesBulkActions,
        selectedRows
      );
    case 'giftingAdmins':
      return getGiftingAdminBulkActionsValues(actions as AdminBulkActions, selectedRows);
    case 'rewardEmployee':
      return getRewardEmployeesBulkActionsValues(
        actions as ReturnType<typeof getRewardEmployeesBulkActions>
      );
    default:
      return { label: '', bulkActions: [] };
  }
}

export default getSortIcon;
